import React, { useContext, useEffect, useState } from "react";
import "./workflow-timeline.component.scoped.scss";
import { CaseContext, GlobalContext } from "../../../../../../../store";
import { useTranslation } from "react-i18next";
import { CasesService } from "../../../../../../../services/cases/cases.service";
import { MapperService } from "../../../../../../../services/mapper/mapper.service";
import { Question } from "../../../../../../../types/question";
import { TimelineStatusesComponent } from "../../../../../../../components/timeline-statuses/timeline-statuses.component";
import { CaseWorkflow } from "../../../../../../../types/case-workflow";
import WorkflowChangeStatus from "../../../../../../../components/workflow-change-status/workflow-change-status.component";
import WorkflowTable from "../workflow-table/workflow-table.component";
import TabContentTitleComponent from "../../../tab-content-title/tab-content-title.component";
import { Box, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

export const WorkflowTimelineComponent = () => {
  const {
    setCaseDetails,
    setWorkflowLoading,
    workflowLoading,
    caseDetails,
    caseStatuses,
    caseQuestions,
    setCaseQuestions,
    setCaseStatuses,
    caseFiles,
  } = useContext(CaseContext);
  const { user } = useContext(GlobalContext);
  const { t } = useTranslation();
  const casesService = new CasesService();
  const mapperService: MapperService = new MapperService();
  // Next and Previous status Buttons in every status.
  const setAvailableStatus = (statuses: any[]) => {
    if (statuses && statuses.length) {
      statuses.forEach((item: any, index: number) => {
        item.prevStatus = index === 0 ? null : { ...statuses[index - 1] };
        item.nextStatus =
          index + 1 === statuses.length ? null : { ...statuses[index + 1] };
      });
    }
    return statuses;
  };

  const [timelineStatuses, setTimelineStatuses] = useState(
    setAvailableStatus(caseStatuses),
  );

  const isActiveStatus = (stageKey: string): boolean => {
    return caseDetails.stage.slug === stageKey;
  };

  const expandStatusComments = (expand: boolean, index: number): void => {
    const timelineStatusesCopy = [...timelineStatuses];
    timelineStatusesCopy[index].expand = expand;
    setTimelineStatuses(timelineStatusesCopy);
  };

  const onUpdateQuestionsStatus = (questions: Question[], index: number) => {
    const caseQuestionCopy = [...caseQuestions];
    caseQuestionCopy[index].questionsStatus = questions.filter(
      (item: Question) => item.answer === null,
    ).length
      ? 0
      : 1;
    caseQuestionCopy[index].questions = questions;
    setCaseQuestions(caseQuestionCopy);
  };

  const fetchCaseDetails = async (id: number) => {
    const caseDetailsData = await casesService.details(id);
    const { mappedCase, mappedtimelineStatuses } = mapperService.mapCase(
      caseDetailsData,
      caseStatuses,
    );
    setCaseDetails(mappedCase);
    setCaseStatuses(mappedtimelineStatuses);
  };

  const fetchCaseQuestions = async (id: number) => {
    setWorkflowLoading(true);
    const caseQuestions = await casesService.caseQuestions(id);
    setTimeout(() => {
      setCaseQuestions(caseQuestions);
      setWorkflowLoading(false);
    }, 100);
  };

  const updateCase = () => {
    fetchCaseDetails(caseDetails.id);
    setTimeout(() => {
      fetchCaseQuestions(caseDetails.id);
    }, 100);
  };

  useEffect(() => {
    setTimelineStatuses(setAvailableStatus(caseStatuses));
  }, [caseStatuses]);

  return (
    <div className="timeline">
      <TabContentTitleComponent
        title={t("USECASE_DETAILS.AI_CHECK_LIST")}
        subTitle={t(
          "USECASE_DETAILS.WE_LL_GUIDE_YOU_THROUGH_THE_ENTIRE_PROCESS_WITH_OUR_QUESTIONS",
        )}
        loading={workflowLoading}
      />
      {/* 
      <div className="head">
        <Box className="right-side">
          {workflowLoading ? (
            <Skeleton variant="text" height={50} width="20rem" />
          ) : (
            <div className="statuses mt-2">
              <FormControl className="select-input" style={{ width: "18rem" }}>
                <InputLabel id="status">{t("SELECT_STATUS")}</InputLabel>
                <Select
                  labelId="status"
                  id="status-select"
                  value={selectedStatues}
                  name="status"
                  onChange={(e: any) => setSelectedStatues(e.target.value)}
                  IconComponent={ExpandMoreIcon}
                  required
                  disabled={user.role === "auditor"}
                >
                  {caseStatuses.map((item: any, index: any) => {
                    return (
                      <MenuItem value={item} key={index}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <Button
                className="btn-primary-theme"
                size="medium"
                variant="contained"
                color="primary"
                onClick={() => changeStatus(selectedStatues)}
                disabled={
                  saving || !selectedStatues || user.role === UserRoles.AUDITOR
                }
              >
                {t("CHANGE_STATUS")}
              </Button>
            </div>
          )}
        </Box>
      </div> */}
      <Box className="global__box__content p-0 mb-3">
        <Box className="global__box__content__header">
          {workflowLoading ? (
            <Skeleton variant="text" height={20} width={350} />
          ) : (
            <Typography variant="h3" color="textPrimary">
              {t("USECASE_DETAILS.CHECKLIST_FOR_RISK_LEVEL_AND_ROLE", {
                riskLevel: caseDetails.riskLevel.name,
                role: caseDetails.role.name,
              })}
            </Typography>
          )}
        </Box>
        <Box className="global__box__content__body">
          <div className="timelines-content">
            <div className="timeline-items">
              {caseQuestions.map((caseQuestion: CaseWorkflow, index: any) => {
                const questions: any[] =
                  !timelineStatuses[index]?.expand && !workflowLoading
                    ? []
                    : caseQuestion.questions;
                return (
                  <TimelineStatusesComponent
                    key={caseQuestion.id}
                    questionsStatus={caseQuestion.questionsStatus}
                    activeStatus={isActiveStatus(caseQuestion.stageKey)}
                    lastStatus={index === timelineStatuses.length - 1}
                    icon={timelineStatuses[index]?.icon}
                    status={caseQuestion.status}
                    date={caseQuestion.date}
                    loading={workflowLoading}
                    expand={timelineStatuses[index]?.expand}
                    handleExpand={(value: boolean) =>
                      expandStatusComments(value, index)
                    }
                    dimmed={timelineStatuses[index]?.dimmed}
                    tab={"workflow"}
                  >
                    {questions && questions.length ? (
                      <WorkflowTable
                        questions={questions}
                        loading={workflowLoading}
                        caseQuestionId={caseQuestion.id}
                        files={caseFiles}
                        statusId={caseDetails.stageId}
                        caseDetails={caseDetails}
                        selectedStatus={
                          caseDetails.stage.slug === caseQuestion.stageKey
                        }
                        onChangeQuestion={(value: Question[]) =>
                          onUpdateQuestionsStatus(value, index)
                        }
                        onUpdateCase={updateCase}
                        user={user}
                      />
                    ) : null}
                    {!workflowLoading &&
                    questions &&
                    questions.length &&
                    caseDetails.stage.slug === caseQuestion.stageKey ? (
                      <WorkflowChangeStatus
                        prevStatus={timelineStatuses[index]?.prevStatus}
                        nextStatus={timelineStatuses[index]?.nextStatus}
                        caseId={caseDetails.id}
                      />
                    ) : null}
                  </TimelineStatusesComponent>
                );
              })}
            </div>
          </div>
        </Box>
      </Box>
    </div>
  );
};
